import { render, staticRenderFns } from "./SalesProperties.vue?vue&type=template&id=8a6df448&"
import script from "./SalesProperties.vue?vue&type=script&lang=js&"
export * from "./SalesProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports